import { DBDriverDynamicPageError } from '../../dynamicPageErrors'
import { DPErrorCodes } from '../../constants'
import type { ExtendedFieldSpec } from '@wix/wix-data-client-common'
import {
  getFieldKeyForUrl,
  PAGE_TYPES,
  parseUrl,
} from '@wix/wix-data-client-common'

export const getItemPageUrl = ({
  routerPrefix,
  collectionFields,
  displayField,
  isTPACollection,
  isEditPage,
}: {
  routerPrefix: string
  collectionFields: ExtendedFieldSpec[]
  displayField?: string
  isTPACollection: boolean
  isEditPage: boolean
}) => {
  const fieldKeyForUrl = getFieldKeyForUrl({
    collectionFields,
    displayField,
    isTPACollection,
  })

  if (!fieldKeyForUrl) {
    if (isTPACollection) {
      throw new DBDriverDynamicPageError(
        DPErrorCodes.NO_FIELD_KEY_IN_DB_DRIVER_COLLECTION,
        `${DPErrorCodes.NO_FIELD_KEY_IN_DB_DRIVER_COLLECTION}: Field key for url does not exist`,
      )
    } else {
      throw new Error('Field key for url does not exist')
    }
  }

  return `${routerPrefix}/${isEditPage ? 'edit/' : ''}{${fieldKeyForUrl}}/`
}

export const getIndexPageUrl = ({ routerPrefix }: { routerPrefix: string }) =>
  `${routerPrefix}/`

export const getPageUrl = ({
  pageType,
  routerPrefix,
  collectionFields,
  displayField,
  isTPACollection,
  isEditPage,
}: {
  pageType: string
  routerPrefix: string
  collectionFields: ExtendedFieldSpec[]
  displayField?: string
  isTPACollection: boolean
  isEditPage: boolean
}) =>
  pageType === PAGE_TYPES.ITEM
    ? getItemPageUrl({
        routerPrefix,
        collectionFields,
        displayField,
        isTPACollection,
        isEditPage,
      })
    : getIndexPageUrl({ routerPrefix })

export const getItemPagePattern = ({
  routerPrefix,
  collectionFields,
  displayField,
  isTPACollection,
}: {
  routerPrefix: string
  collectionFields: ExtendedFieldSpec[]
  displayField?: string
  isTPACollection: boolean
}) => {
  const url = getItemPageUrl({
    routerPrefix,
    collectionFields,
    displayField,
    isTPACollection,
    isEditPage: false,
  })

  const { pattern } = parseUrl(url)
  return pattern
}
